// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.freezer_box_1 {
  background-color: var(--ColorPrimary);
  margin-top: 3rem;
  box-shadow: 0px 0px 26px -5px rgba(0, 0, 0, 0.75);
  border-radius: 20px;
  width: 100%;
  padding: 3rem;
}
.freezer_box_2 {
  background-color: var(--ColorPrimary);
  margin-top: 5rem;
  border-radius: 20px;
  width: 100%;
  padding: 3rem;
}
`, "",{"version":3,"sources":["webpack://./src/components/freezerComponentDetails/freezerDetails.css"],"names":[],"mappings":"AAAA;EACE,qCAAqC;EACrC,gBAAgB;EAChB,iDAAiD;EACjD,mBAAmB;EACnB,WAAW;EACX,aAAa;AACf;AACA;EACE,qCAAqC;EACrC,gBAAgB;EAChB,mBAAmB;EACnB,WAAW;EACX,aAAa;AACf","sourcesContent":[".freezer_box_1 {\n  background-color: var(--ColorPrimary);\n  margin-top: 3rem;\n  box-shadow: 0px 0px 26px -5px rgba(0, 0, 0, 0.75);\n  border-radius: 20px;\n  width: 100%;\n  padding: 3rem;\n}\n.freezer_box_2 {\n  background-color: var(--ColorPrimary);\n  margin-top: 5rem;\n  border-radius: 20px;\n  width: 100%;\n  padding: 3rem;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
